import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

import { Button, LinkTo, renderField } from '../../../helpers';

function SignupForm({ isLoading, successMessage, errorMessage, handleSubmit, onSubmit }) {
  return (
    <form className="floating-labels m-t-40" onSubmit={handleSubmit(user => onSubmit(user))}>
      {successMessage ? (
        <div className="alert alert-success">
          {successMessage}
        </div>
      ) : null}

      <Field material required name="first_name" component={renderField} className="form-control" label="First Name" />
      <Field material required name="last_name" component={renderField} className="form-control" label="Last Name" />
      <Field material required name="email" component={renderField} className="form-control" label="Email" />
      <Field
        material
        required
        name="password"
        type="password"
        component={renderField}
        className="form-control"
        label="Password"
      />
      <Field
        material
        required
        name="passwordConfirmation"
        type="password"
        component={renderField}
        className="form-control"
        label="Confirm Password"
      />

      {errorMessage ? (
        <div className="alert alert-danger">
          {errorMessage}
        </div>
      ) : null}

      <div className="form-group m-b-40">
        <div className="col-md-12">
          <LinkTo href="auth/reset" className="text-dark pull-right">
            <i className="fa fa-lock" /> Forgot password?
          </LinkTo>
        </div>
      </div>

      <div className="form-group text-center m-t-20">
        <div className="col-xs-12">
          <Button
            submit
            disabled={isLoading}
            className="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
          >
            {isLoading ? 'Processing...' : 'Sign Up'}
          </Button>
        </div>
      </div>
    </form>
  );
}

SignupForm.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

SignupForm.defaultProps = {
  successMessage: null,
  errorMessage: null
};

function validate({ username, email, password, passwordConfirmation }) {
  const errors = {};

  if (!username) {
    errors.username = 'Please enter a username';
  }

  if (!email) {
    errors.email = 'Please enter an email';
  }

  if (!/\S+@\S+\.\S+/.test(email)) {
    errors.email = 'Please enter a valid email';
  }

  if (!password) {
    errors.password = 'Please enter a password';
  }

  if (!passwordConfirmation) {
    errors.passwordConfirmation = 'Please enter a password confirmation';
  }

  if (password !== passwordConfirmation) {
    errors.password = 'Passwords must match';
  }

  return errors;
}

export default reduxForm({ form: 'signup', validate })(SignupForm);
